import React from 'react';
import FooterLogo from '../../assets/images/codemasters_logo_notext.svg';

export default function Footer(props) {
    return (
        <footer className="footer">
            <div className="row">
                <div className="col-md-8 offset-md-2">
                    <div className="footer__logo">
                        <img src={FooterLogo} alt="codemasters-logo" />
                    </div>
                    <p>&copy; 2019 The Codemasters Software Company Limited (&quot;Codemasters&quot;). All rights reserved. &quot;Codemasters&quot;&reg; and the Codemasters logo&reg; are registered trademarks owned by Codemasters. All Rights Reserved. All other trademarks or copyrights are the property of their respective owners and are used under license. Developed and published by Codemasters.</p>
                    <br />
                    <nav>
                        <ul>
                            <li><a href={props.settings.contactUs} target="_blank" rel="noopener noreferrer">Contact Us</a></li>
                            <li><a href={props.settings.termsAndCond} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></li>
                            <li><a href={props.settings.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
                            <li><a href={props.settings.modernSlavery}>Modern Slavery Statement</a></li>
                            <li><a href={props.settings.genderGap}>Gender Pay Gap Report</a></li>
                        </ul>
                    </nav>
                </div>
            </div>

        </footer>
    )
}
